<template>
  <div class="portal-layout full-height q-pt-xl">
   <div class="row justify-right">
      <div class="offset-md-4 offset-xs-1 col-md-4 col-xs-10">
      <OfficeSet auto-select-office></OfficeSet>
      </div>
      <div class="q-ma-lg offset-xs-1 col-md-2 col-xs-10">
        <!-- 
        <OfficeAdministrationSwitch />
        -->
        <LastLoginFeedback />
      </div>
    </div>
  </div>
</template>

<script>
import OfficeSet from "./OfficeSet";
import LastLoginFeedback from "./LastLoginFeedback";
//import OfficeAdministrationSwitch from "./OfficeAdministrationSwitch";

export default {
  name: "PortalLayout",
  components: {
    OfficeSet,
    LastLoginFeedback
    //OfficeAdministrationSwitch
  },
};
</script>
<style lang="scss">
.portal-layout {
  background: rgb(10,0,182);
  background: linear-gradient(150deg, rgba(10,0,182,1) 0%, rgba(68,68,147,1) 36%, rgba(8,184,219,1) 100%);
}
</style>
